import z from 'zod'
import { API_METHODS, callApi, createApiFunction } from './apiProvider'

const MIN_PREVIEW_URLS_REFRESH_DELAY_MS = 10 * 1000

const PhotoPreviewUrlsSchema = z.object({
  min: z.string(),
  high: z.string(),
})

const PhotoPreviewUrlsResponseSchema = z
  .object({
    previews: z.record(z.string(), PhotoPreviewUrlsSchema),
    // Keys whose previews the backend hasn't built yet, to request again
    pendingKeys: z.array(z.string()),
    expiresAt: z.string().datetime(),
  })
  .transform(({ previews, pendingKeys, expiresAt }) => ({
    previews,
    pendingKeys,
    expiresAtMs: Date.parse(expiresAt),
  }))

export async function fetchPhotoPreviewUrls(
  keys: string[]
): Promise<z.infer<typeof PhotoPreviewUrlsResponseSchema>> {
  const data = await callApi(
    createApiFunction(API_METHODS.POST, '/v1/photos/preview-urls', { keys })
  )
  return PhotoPreviewUrlsResponseSchema.parse(data)
}

// Re-signed at half the time left, so a request that is slow or a tab that wakes up late still has margin
export function getPreviewUrlsRefreshDelayMs(
  expiresAtMs: number,
  nowMs: number
): number {
  return Math.max((expiresAtMs - nowMs) / 2, MIN_PREVIEW_URLS_REFRESH_DELAY_MS)
}
